import { Temporal } from 'temporal-polyfill';
import { ICalendarEventMinimumData } from './types/ICalendarEvent';

/**
 * Generates an array of PlainDates since the given day.
 * @param from - The first date of the array.
 * @param numberOfDays - The number of days to generate.
 * @returns
 */
function getWeekDays(from: Temporal.PlainDate, numberOfDays = 7): Array<Temporal.PlainDate> {
	const days = [];

	for (let i = 0; i < numberOfDays; i++) {
		days.push(from.add({ days: i }));
	}

	return days;
}

/**
 * Helper function to generate events for testing.
 *
 * This will be moved to the spec once finished development.
 */
export function $generateEvent(hourStart: number, hourEnd: number) {
	return {
		id: crypto.randomUUID(),
		start: Temporal.ZonedDateTime.from({
			year: 2024,
			month: 4,
			day: 10,
			hour: hourStart,
			minute: 0,
			timeZone: 'Europe/Madrid',
		}),
		end: Temporal.ZonedDateTime.from({
			year: 2024,
			month: 4,
			day: 10,
			hour: hourEnd,
			minute: 0,
			timeZone: 'Europe/Madrid',
		}),
		description: hourStart + ' - ' + hourEnd,
	};
}

/**
 * Generates a Record with string plainDates as keys and array of calendar events as value.
 * O(n)
 * @param calendarEvent
 * @returns
 */
function assignEventToPlainDates<TEvent extends ICalendarEventMinimumData>(
	calendarEvent: Array<TEvent>
): Record<string, Array<TEvent>> {
	const groupedEvents: Record<string, TEvent[]> = {};

	calendarEvent.forEach((e) => {
		const startDate = e.start.toPlainDate();
		const endDate = _closeInterval(e.end);

		// Events spanning multiple days
		if (!startDate.equals(endDate)) {
			let currentDate = startDate;
			while (Temporal.PlainDate.compare(currentDate, endDate) <= 0) {
				_addEventToGroup(groupedEvents, currentDate.toString(), e);
				currentDate = currentDate.add({ days: 1 });
			}
		}

		_addEventToGroup(groupedEvents, startDate.toString(), e);
	});

	return groupedEvents;
}

/**
 * Add an event to an array.
 * If the array does not exist will create it
 */
function _addEventToGroup<TEvent extends ICalendarEventMinimumData>(
	groupedEvents: Record<string, TEvent[]>,
	day: string,
	event: TEvent
) {
	return groupedEvents[day] ? groupedEvents[day].push(event) : (groupedEvents[day] = [event]);
}

/**
 * This is a terrible fix :(
 *
 * When an event ends at 00:00:00 it ends during the next day but we want to display it the same day.
 * We basically move it to the latest instant of the previous day.
 */
function _closeInterval(time: Temporal.ZonedDateTime): Temporal.ZonedDateTime {
	if (time.hour === 0 && time.minute === 0 && time.second === 0 && time.millisecond === 0) {
		return time.subtract({ days: 1 }).with({
			hour: 23,
			minute: 59,
			second: 59,
			millisecond: 999,
			microsecond: 99999,
		});
	}

	return time;
}

export default { getWeekDays, assignEventToPlainDates };
